/** @type {import("@commonClient2/typings").SortType} */
export const defaultSortType = 'asc';
export const employeeNameDataKey = 'employeeName';
export const rankDataKey = 'rank';
export const sequentialEmployeeTurn = 'scheduledDateAndTime';

/**
 * @param {ManagerAppData.IEmployee[]} data
 * @param {string} sortColumn
 * @returns string
 */
export const getSortPathByKey = (data, sortColumn) => {
    if (!data.length) {
        return '';
    }
    const nonDataviewAttributes = [employeeNameDataKey, rankDataKey, sequentialEmployeeTurn];
    if (nonDataviewAttributes.includes(sortColumn)) {
        return sortColumn;
    }

    const [firstRow] = data;
    const dataviewAttributesIndex = firstRow.dataviewAttributes.findIndex((attribute) => attribute.key === sortColumn);
    return `dataviewAttributes[${dataviewAttributesIndex}].value`;
};
